import{useAppDispatch}from'./useAppDispatch';/**
 * Provides a `getState()` function to hooks.
 * You should prefer `useAppSelector` when possible.
 */function useGetState(){var dispatch=useAppDispatch();return function(){return dispatch(function(_,getState){return getState();});};}export{useGetState};